import { cva } from 'class-variance-authority';

/**
 * Kept out of button.tsx so that module exports only its component: Fast Refresh
 * discards a module's state whenever it also exports something that is not a component,
 * which is what react-refresh/only-export-components guards against. Importing these
 * variants directly is also how a link or a Radix trigger gets a button's appearance
 * without nesting an actual <button>.
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground shadow-glow hover:brightness-110 active:brightness-95',
        outline: 'border border-border bg-transparent hover:bg-muted/50',
        ghost: 'hover:bg-muted/50',
        danger: 'bg-danger text-danger-foreground hover:brightness-110',
        glass: 'glass hover:border-primary/60',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-8 rounded-sm px-3 text-xs',
        lg: 'h-12 rounded-lg px-6 text-base',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
);
